import startOfDay from 'date-fns/startOfDay'
import { IAvailableDaysFactory } from '../../entities/available-days/AvailableDays'
import { parseIsoDate } from '../../utils/parse-date'

export type IAvailableDaysResponse = Record<string, number>

export const transformAvailableDays = (date: IAvailableDaysResponse): IAvailableDaysFactory => {
  const days = new Map<string, number>()
  const clientToday = startOfDay(new Date())

  Object.entries(date).forEach(([dateKey, count]) => {
    const parsedDate = parseIsoDate(dateKey)
    const startOfDayDate = startOfDay(parsedDate)

    if (startOfDayDate.getTime() < clientToday.getTime()) {
      return
    }

    days.set(startOfDayDate.toString(), count)
  })

  return {
    days,
  }
}
